export interface PaginatedHistoryMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface PaginatedHistoryResponse<T> {
  data: T[];
  meta: PaginatedHistoryMeta;
}

export const HISTORY_PAGE_SIZE = 25;
